import React from "react";
import { Link } from "react-router-dom";
class MastersList extends React.Component {
  render() {
    return (
      <>
        <div className="row align-items-center no-gutters">
          <div className="col-md-9">
            <h1 className="heading m-b-0">Masters </h1>
          </div>
        </div>
        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-12">
            <div className="box-card">
              <div className="row">
                <div className="col-md-6" />
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <a className="form-control-plaintext" href={`/roles-list`}>
                      Roles
                    </a>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <a
                      href={`/messageConfiguration-list`}
                      className="form-control-plaintext"
                    >
                      {" "}
                      Message Configuration
                    </a>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <a
                      href={`/auto-numbering-list`}
                      className="form-control-plaintext"
                    >
                      Auto Numbering
                    </a>
                  </div>
                </div>
              </div>
              <div class="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <a
                      href={`/master-profile`}
                      className="form-control-plaintext"
                    >
                      Generic Master
                    </a>
                  </div>
                </div>
                {/* <div className="col-md-4">
                  <div className="form-group">
                    <a
                      href={`/projectMapping-list`}
                      className="form-control-plaintext"
                    >
                      Project Mapping
                    </a>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <a
                      href={`/super-admin-list`}
                      className="form-control-plaintext"
                    >
                      Super Admin
                    </a>
                  </div>
                </div> */}
              </div>
              {/* <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <a href={`/holiday-list`}
                      className="form-control-plaintext">Holidays</a>
                    
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <a href={`/roles-list`}
                      className="form-control-plaintext">Roles</a>
                    
                  </div>
                </div>
              
                <div className="col-md-4">
                  <div className="form-group">
                    <a href={`/frequentlyLoggedComplaints-list`}
                      className="form-control-plaintext">
                        Frequently Logged Complaints
                      </a>
                    
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <a href={`/messageConfiguration-list`}
                      className="form-control-plaintext">
                        Message Configuration
                      </a>
                    
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <a href={`/escalationplan-list`}
                      className="form-control-plaintext">Escalation Plan</a>
                    
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <a href={`/escalation-evaluator-list`}
                      className="form-control-plaintext">
                        Map Escalation Plan
                      </a>
                    
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <a href={`/brandMapping-list`}
                      className="form-control-plaintext">
                        Brand Classification Mapping
                      </a>
                    </a>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default MastersList;
